/* eslint-disable no-prototype-builtins */
import { roleDetail }  from '@/service/sys'
import { addRouters } from '@/router/fliter'
import { 
  getStorageToken,
  setStorageMenuByRole, 
  getStorageAdminUser, 
  getStorageMenuByRole, 
  // setStorageUserRoleName
} from '@/utils/store'
import { vueComment } from '@/router/config'
import GongYeSuPaiEvent from '@/monitor'
// import WS from '@/webSocket'

let hideMeu = []
for (const key in vueComment) {
  if (vueComment[key].hideMenu) {
    hideMeu.push(key)
  }
}
const app = {
  namespaced: true, 
  state: {
    userRoleId: '',
    userData: getStorageAdminUser(),
    currentMenu: {},
    menuList: [],
    menuMapById: {},
    menuMapByPathName: {},
    openGroups: [],
    tabList: [],
    tabActiveMenu: {},
    actionsWithoutPermission: [],
  },
  mutations: {
    SET_USERDATA: (state, data) => {
      state.userData = data
    },
    SET_ACTIONS_WITHOUT_PERMISSION: (state, arr) => {
      state.actionsWithoutPermission = arr
    },
    CHOOSE_TABLIST: (state, item) => {
      let ids = state.tabList.map(obj => obj.id)
      if (ids.indexOf(item.id) == -1) {
        state.tabList.push(item)
      } else {
        state.tabList.splice(ids.indexOf(item.id), 1, item)
      }
      state.tabActiveMenu = item
    },
    REMOVE_TABLIST: (state, data) => {
      let ids = state.tabList.map(obj => obj.id)
      if (ids.indexOf(data.id) != -1) {
        state.tabList.splice(ids.indexOf(data.id),1)
      }
      if (state.tabList.length) {
        state.tabActiveMenu = state.tabList[state.tabList.length - 1]
      }
      data.cb && data.cb(state.tabActiveMenu)
    },
    REMOVE_TABS: (state, type) => {
      let ids = state.tabList.map(obj => obj.id)
      let index = ids.indexOf(state.tabActiveMenu.id)
      switch (type) {
        case 'left':
          state.tabList.splice(0, index)
          break;
        case 'right':
          state.tabList.splice(index+1, 99999)
          break;
        default:
          state.tabList = [state.tabActiveMenu]
          break;
      }
    },
    LOGIN_OUT: (state) => {
      state.userRoleId = ''
      state.currentMenu = {}
      state.menuList = []
      state.menuMapById = {}
      state.menuMapByPathName = {}
      state.openGroups = []
    },
    SET_OPEN_GROUPS: (state, list) => {
      state.openGroups = list
    },
    SET_MENU_LIST: (state, list) => {
      let menuids = {}
      let menuName = {}
      // list.map(group => {
      //   group.children.map(menu => {
      //     menuids[menu.id] = menu
      //     menuName[menu.pathName] = menu
      //   })
      // })
      list.map(group => {
        group.children.map(menu => {
          if (menu.is_group) {
            menu.children && menu.children.length && menu.children.map(gmenu => {
              menuids[gmenu.id] = gmenu
              menuName[gmenu.pathName] = gmenu
            })
          } else {
            menuids[menu.id] = menu
            menuName[menu.pathName] = menu
          }
        })
      })
      state.menuList = list
      state.menuMapById = menuids
      state.menuMapByPathName = menuName
    },
    SET_USER_ROLE_ID: (state, id) => {
      state.userRoleId = id
    },
    SET_CURRENT_MENU: (state, data) => {
      state.currentMenu = data
    },
  },
  actions: {
    setUserData({ commit }, data) {
      commit('SET_USERDATA',data)
    },
    chooseNavTab({ commit }, item) {
      commit('CHOOSE_TABLIST', item)
    },
    removeTabList({ commit }, data) {
      commit('REMOVE_TABLIST', data)
    },
    removeTabs({ commit }, type) {
      commit('REMOVE_TABS', type)
    },
    loginOut({ commit }) {
      commit('LOGIN_OUT')
    },
    setOpenGroups({ commit }, list) {
      commit('SET_OPEN_GROUPS', list)
    },
    setCurrentMenu({ commit }, data) {
      GongYeSuPaiEvent.trigger(GongYeSuPaiEvent.key.SET_CURRENT_MENU, data)
      commit('SET_CURRENT_MENU', data)
    },
    setUserRole({ commit, state, rootGetters }, data) {
      // console.log("unreadNum  ",rootGetters);
      let roleId = data.id
      let isLoad = !!data.isLoad
      return new Promise((resovle) => {
        commit('SET_USER_ROLE_ID', roleId)
        let sarr = getStorageMenuByRole(roleId)
        if (sarr.length && !isLoad) {
          setStorageMenuByRole(roleId, sarr)
          addRouters(sarr)
          commit('SET_MENU_LIST', sarr)
          resovle(1)
        } else {
          if (!roleId || isNaN(roleId) || roleId == 'undefined') {
            resovle(0)
            return
          }
          let params = {
            AccountID:roleId,
            Token:getStorageToken(),
            platform: 'pcweb'
          }
          roleDetail(params).then(res=>{
            if (res.Result != 1) {
              resovle(0)
              return 
            }

            // D--修改
            // console.log('菜单原始数据 ',res.Data)
            res.Data.push(
            // {
            //   children: [
            //     {
            //       children:[
            //         {
            //           children: null,
            //           id: 130,
            //           is_open: 1,
            //           is_show: 1,
            //           menu_code: "010108",
            //           name: "角色配置",
            //           parent_id: 103,
            //           type: 1,
            //           url: "roleConfig",
            //         },
            //       ],
            //       id: 14,
            //       is_group: true,
            //       is_open: 1,
            //       is_show: 1,
            //       menu_code: "110104",
            //       name: "系统管理",
            //       parent_id: 103,
            //       sort: 14,
            //       status: 1,
            //       type: 2,
            //       url: null,
            //     }
            //   ],
            //   is_open: 1,
            //   is_show: 1,
            //   id:103, // 这个id一定要有
            //   name: "系统配置",
            //   menu_code: "410101",
            //   is_group: false,
            //   parent_id: 0,
            //   type: 1,
            //   url: 'system'
            // }
            // {
            //   children: [
            //     {
            //       children: null,
            //       id: 10020,
            //       is_open: 1,
            //       is_show: 1,
            //       menu_code: "1001000",
            //       name: `私聊`,
            //       tips: rootGetters.getUnreadAll.contact ? rootGetters.getUnreadAll.contact : '',
            //       parent_id: 10070,
            //       type: 1,
            //       url: "chatContent",
            //     }
            //   ],
            //   is_open: 1,
            //   is_show: 1,
            //   id:10070, // 这个id一定要有
            //   name: "市场管理",
            //   menu_code: 1100000,
            //   is_group: false,
            //   parent_id: 0,
            //   type: 1,
            //   url: 'market'
            // },

              // {
              //   children: [
              //     {
              //       children: null,
              //       id: 150100,
              //       is_open: 1,
              //       is_show: 1,
              //       menu_code: "150100",
              //       name: "平台协议",
              //       parent_id: 150000,
              //       type: 1,
              //       url: "agreement",
              //     },
              //   ],
              //   is_open: 1,
              //   is_show: 1,
              //   id:150000, // 这个id一定要有
              //   name: "合同条款",
              //   menu_code: 150000,
              //   is_group: false,
              //   parent_id: 0,
              //   type: 1,
              //   url: 'contract'
              // }
            )
            // END








            // console.log('---- ',res.Data)





            // setStorageUserRoleName(res.Data.AccountName)
            let newMenu = []
            // let actionsPermissionList = []
            // res.Data.Menus.map(group => {
            //   if (group.is_open && group.is_show) {
            //     let newGroup = {
            //       id: group.id,
            //       name: group.name,
            //       status: group.status,
            //       sort: group.sort,
            //       url: group.url,
            //       parent_id: group.parent_id
            //     }
            //     let groupChild = []
            //     let menuChildLength = 0
            //     group.children.map(menu => {
            //       if (menu.is_open) {
            //         let newMenu = {
            //           id: menu.id,
            //           name: menu.name,
            //           status: menu.status,
            //           sort: menu.sort,
            //           url: menu.url,
            //           parent_id: menu.parent_id,
            //           path: `/${group.url}/${menu.url}`,
            //           pathName: group.url + menu.url.charAt(0).toUpperCase() + menu.url.slice(1),
            //           parent_name: group.name,
            //           openUrl: group.openUrl
            //         }
            //         if (hideMeu.indexOf(newMenu.pathName) != -1) {
            //           newMenu.hideMenu = true
            //         } else {
            //           menuChildLength++
            //         }
            //         groupChild.push(newMenu)
            //         menu.children && menu.children.map(action => {
            //           if (action.is_open == 2 && !action.is_has) {
            //             actionsPermissionList.push(action.menu_code)
            //           }
            //         })
            //       }
            //     })
            //     newGroup.children = groupChild
            //     newGroup.menuChildLength = menuChildLength
            //     newMenu.push(newGroup)
            //   }
            // })
            res.Data.map(group => {
              function bkMenu(menu, is_group, group_id) {
                let pathName = group.url + menu.url.charAt(0).toUpperCase() + menu.url.slice(1)
                return {
                  id: menu.id,
                  name: menu.name,
                  url: menu.url,
                  parent_id: menu.parent_id,
                  path: `/${group.url}/${menu.url}`,
                  pathName,
                  parent_name: group.name,
                  openUrl: group.openUrl,
                  group_id,
                  is_group_menu: !!is_group,
                  tips: menu.tips,
                  hideMenu: (hideMeu.indexOf(pathName) != -1)
                }
              }
              if (group.is_open && group.is_show) {
                let newGroup = {
                  id: group.id,
                  name: group.name,
                  // status: group.status,
                  // sort: group.sort,
                  url: group.url,
                  parent_id: group.parent_id
                }
                let groupChild = []
                group.children.map(menu => {
                  if (menu.is_open && !menu.is_group) {
                    groupChild.push(bkMenu(menu))
                  } else if (menu.is_group && menu.children && menu.children.length) {
                    groupChild.push(
                      {
                        name: menu.name,
                        id:menu.id, // 这个id一定要有
                        is_group: true,
                        children: menu.children.map(item => bkMenu(item, true, menu.id))
                      }
                    )
                  }
                })
                newGroup.children = groupChild
                newMenu.push(newGroup)

              }
            })

            // console.log(newMenu)
            setStorageMenuByRole(roleId, newMenu)
            // console.log(888888, newMenu)
            addRouters(newMenu)
            commit('SET_MENU_LIST', newMenu)
            // commit('SET_ACTIONS_WITHOUT_PERMISSION', actionsPermissionList)
            resovle(1)
          }).catch((e) => {
            console.log('登录', e)
            resovle(0)
          })
        }
      })
    }
  }
}

export default app
